import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { supabase } from '../lib/supabase';

const WelcomeBanner = ({ variant = 'default' }) => {
  const { user } = useAuth();
  const [firstName, setFirstName] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadUserName = async () => {
      if (!user) {
        setLoading(false);
        return;
      }

      try {
        // First try to get from users table
        const { data: userData, error } = await supabase
          .from('users')
          .select('first_name, full_name')
          .eq('id', user.id)
          .single();

        if (!error && userData) {
          // Prefer first_name, fall back to parsing full_name, then email
          if (userData.first_name) {
            setFirstName(userData.first_name);
          } else if (userData.full_name) {
            // Parse first word from full name
            setFirstName(userData.full_name.split(' ')[0]);
          } else {
            // Fall back to email prefix
            setFirstName(user.email?.split('@')[0] || 'there');
          }
        } else {
          // Fall back to auth metadata
          const metaFirstName = user.user_metadata?.first_name;
          const metaFullName = user.user_metadata?.full_name;
          
          if (metaFirstName) {
            setFirstName(metaFirstName);
          } else if (metaFullName) {
            setFirstName(metaFullName.split(' ')[0]);
          } else {
            setFirstName(user.email?.split('@')[0] || 'there');
          }
        }
      } catch (error) {
        console.error('Error loading user name:', error);
        // Fall back to email prefix
        setFirstName(user.email?.split('@')[0] || 'there');
      } finally {
        setLoading(false);
      }
    };

    loadUserName();
  }, [user]);

  if (loading) {
    return (
      <div className={getContainerClass(variant)}>
        <span className="animate-pulse">👋 Welcome!</span>
      </div>
    );
  }

  // Capitalize first letter
  const displayName = firstName 
    ? firstName.charAt(0).toUpperCase() + firstName.slice(1)
    : 'there';

  return (
    <div className={getContainerClass(variant)}>
      <span>👋 Welcome, {displayName}!</span>
    </div>
  );
};

// Helper function to get container classes based on variant
function getContainerClass(variant) {
  switch (variant) {
    case 'gradient':
      return 'text-white font-medium text-sm sm:text-base';
    case 'dark':
      return 'text-gray-900 font-medium text-sm sm:text-base';
    case 'light':
      return 'text-gray-600 font-medium text-sm sm:text-base';
    default:
      return 'text-gray-700 font-medium text-sm sm:text-base';
  }
}

export default WelcomeBanner;